import { convertStringToNumber } from '../../common/utils';

const convertMinMax = (value: string): number | null => {
  if (!value.length) {
    return null;
  }

  return convertStringToNumber(value);
};

const convertMinMaxToString = (value: number | null): string => {
  if (value === null) {
    return '';
  }

  return String(value);
};

export { convertMinMax, convertMinMaxToString };
